import { cva } from 'class-variance-authority'

export const alertRootVariant = cva(
  'flex flex-col gap-2 rounded border-l-4 p-4 shadow-md',
  {
    variants: {
      color: {
        default: 'border-secondary bg-white',
        yellow: 'border-yellow bg-[#FEFAF1]',
        red: 'border-red bg-[#FEF6F7]'
      }
    }
  }
)

export const alertTitleVariant = cva(
  'flex items-center gap-2 text-base font-bold',
  {
    variants: {
      color: {
        default: 'text-black',
        yellow: 'text-yellow',
        red: 'text-red'
      }
    }
  }
)
